export default {
    pageTitle: 'Competency Profiles',
    createProfile: 'Create Profile',
    employees_one: '{{count}} employee',
    employees_other: '{{count}} employees',
    competencies_one: '{{count}} competency',
    competencies_other: '{{count}} competencies',
    addCompetency: 'Add Competency',
    actions: {
        editProfile: 'Edit Profile',
        assignProfile: 'Assign Profile',
        viewEmployees: 'View Employees with Profile',
        deleteProfile: 'Delete Profile',
    },
    deleteProfile: {
        title: 'Delete Profile',
        titleWithName: 'Delete the “{{name}}” profile',
        message: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
        irreversible: 'This action is irreversible and applies retroactively.',
        summary:
            'This profile contains {{groupCount}} groups covering {{competencyCount}} competencies. Deleting it will remove all associated groups and competencies for {{employeeCount}} employees.',
        loading: 'Calculating the impact…',
        reassignLabel: 'Reassign employees to another profile',
        reassignHelper:
            'Choose a replacement profile, or leave employees without an assigned profile.',
        reassignNone: 'None (employees will no longer have a profile)',
        confirm: 'Delete permanently',
        cancel: 'Cancel',
    },
    editProfileModal: {
        title: 'Edit Profile',
        subtitle: 'Update the profile name and description',
        nameLabel: 'Profile name',
        namePlaceholder: 'Enter profile name',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Enter description',
        save: 'Save',
        cancel: 'Cancel',
    },
    createProfileModal: {
        title: 'Create Profile',
        subtitle: 'Add a profile name and description',
        nameLabel: 'Profile name',
        namePlaceholder: 'Enter profile name',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Enter description',
        create: 'Create',
        cancel: 'Cancel',
        todoNote:
            'TODO: This create modal currently mirrors edit behavior (name + description). Expand with full creation UX when final design is available.',
    },
    messages: {
        createSuccess: 'Profile created successfully.',
        createError: 'Unable to create profile. Please try again.',
        updateSuccess: 'Profile updated successfully.',
        updateError: 'Unable to update profile. Please try again.',
        deleteSuccess: 'Profile deleted successfully.',
        deleteError: 'Unable to delete profile. Please try again.',
    },
    addCompetencyModal: {
        title: 'Add competencies to {{profileName}}',
        searchPlaceholder: 'Search...',
        allGroups: 'All groups',
        selectGroup: '+ Select group ({{count}})',
        alreadyAdded: 'Added',
        selected: 'Selected',
        revisionButton: 'Revision ({{count}})',
        close: 'Close',
        revisionTitle: 'Revision, {{profileName}}',
        revisionSubtitle:
            '{{current}} current competencies + {{new}} new = {{total}} competencies total',
        revisionSubtitlePrefix: '{{current}} current competencies + {{new}} new',
        revisionSubtitleTotal: '{{total}} competencies total',
        competenciesToAdd: 'Competencies to add ({{count}})',
        importantLabel: 'Important:',
        importantNoticePrefix: 'This change will apply to all employees who have the',
        importantNoticeSuffix: 'profile assigned in their file.',
        importantNotice:
            'This change will apply to all employees who have the « {{profileName}} » profile assigned in their file.',
        back: 'Back',
        confirm: 'Confirm addition ({{count}})',
        errorMessage: 'An error occurred. Please try again.',
    },
    deleteCompetency: {
        title: 'Remove Competency',
        message: 'Are you sure you want to remove this competency from the profile?',
        confirm: 'Remove',
        cancel: 'Cancel',
    },
    createWizard: {
        pageTitle: 'Creating competency profile',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        create: 'Create',
        steps: {
            employeeProfile: 'Employee Profile',
            selectCompetencies: 'Select competencies',
            proficiencyLevels: 'Proficiency levels',
            review: 'Review',
        },
        employeeProfile: {
            infoBanner: 'Answer a few questions to personalize suggestions of competencies',
            questionProgress: 'Question {{current}} of {{total}}',
            percentComplete: '{{percent}}% complete',
            questionBadge: 'Question',
            yes: 'Yes',
            no: 'No',
            questions: {
                q1: 'Does that person have contact with clients?',
                q2: 'Does that person manage a team?',
                q3: 'Does that person handle confidential data?',
                q4: 'Does that person work with external partners?',
                q5: 'Does that person make budget decisions?',
                q6: 'Does that person mentor other employees?',
            },
        },
        selectCompetencies: {
            title: 'Select competencies',
            placeholder: 'Competency selection will be available here.',
            selectedCount_one: '{{count}} competency selected',
            selectedCount_other: '{{count}} competencies selected',
            loading: 'Loading competencies...',
            error: 'Unable to load competencies. Please try again.',
            empty: 'No competency groups available.',
        },
        proficiencyLevels: {
            title: 'Proficiency levels',
            placeholder: 'Proficiency level configuration will be available here.',
            infoBanner: 'Define the expected proficiency level for each competency',
            subtitle: 'Set the expected mastery level for each selected competency',
            levels: {
                junior: 'Junior',
                inEvolution: 'In evolution',
                satisfactory: 'Satisfactory',
                advanced: 'Advanced',
                expert: 'Expert',
            },
            categories: {
                leadership: {
                    name: 'Leadership and team management',
                    competencies: {
                        teamLeadership: {
                            name: 'Team leadership',
                            description: 'Ability to lead and inspire team members',
                        },
                        talentDevelopment: {
                            name: 'Talent development',
                            description: 'Ability to support and grow team members',
                        },
                    },
                },
            },
        },
        review: {
            title: 'Review',
            placeholder: 'Review your competency profile before creating it.',
            infoBanner: 'Review and confirm the profile before assigning it',
            subtitle: 'Verify the profile before assigning it to the employee',
            nameLabel: 'Name this competency profile',
            nameTooltip:
                'Examples of profile names: Senior Sales Profile, Full Stack Developer, Junior Marketing Analyst, Project Manager, Senior UX Designer...',
            namePlaceholder: 'Ex: Senior Sales Profile, Full Stack Developer',
            addDescription: '+ Add a description',
            descriptionLabel: 'Description (optional)',
            descriptionPlaceholder: 'Ex: Description of the competency profile...',
            summaryTitle: 'Profile summary',
            totalCompetencies: 'Total competencies',
            priorityCompetencies: 'Priority competencies',
            competenciesByLevel: 'Competencies by level',
            levelLabel: '{{level}} ({{count}})',
            levelAdvanced: 'Advanced',
        },
    },
};
